import React from 'react'
import Subject from './Subject'
import csm from '../assets/ASH401mid21.pdf'
import cse from '../assets/ASH401end21.pdf'
export default function Ob() {
  return (
    <>
    
    <Subject title="Organizational Behaviour(ASH401)" sub="OB" syllabus="#"mid="Q. Paper"
    book1="Robbins, Stephen P. and Timothy A. Judge: Organisational Behaviour."
    book1Link="https://www.pdfdrive.com/download.pdf?id=14352545&h=ebb7f453a676c305242e64af042109f4&u=cache&ext=pdf" 
    int21="#" mid21={csm} end21={cse}
     int20="#" mid20="#" end20="#"
    />
    
    </>
  )
}
